import { doc, getFirestore } from 'firebase/firestore'
import { getRecordsCollectionName } from './getRecordsCollectionName'

export const getRecordsRef = (id: string) => {
  const db = getFirestore()

  return doc(db, getRecordsCollectionName(), id)
}
